// extracted by mini-css-extract-plugin
module.exports = {"benefits":"SectionBenefits-module--benefits--27epv","background":"SectionBenefits-module--background--30FJ_","triangle":"SectionBenefits-module--triangle--EdHCJ"};